import { createTheme } from '@mui/material/styles';

const sol = {
  text: '#2C2622',
  textMuted: '#6B5E54',
  bg: '#FFF9F2',
  surface: '#F0E4D4',
  brand: '#1A5F7A',
  accent: '#2E8A9E',
  cta: '#B55222',
  ctaHover: '#9E4518',
  footer: '#1F3A44',
};

const theme = createTheme({
  palette: {
    primary: {
      main: sol.brand,
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: sol.cta,
      dark: sol.ctaHover,
      contrastText: '#FFFFFF',
    },
    background: {
      default: sol.bg,
      paper: sol.surface,
    },
    text: {
      primary: sol.text,
      secondary: sol.textMuted,
    },
  },
  typography: {
    fontFamily: '"Open Sans", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          color: sol.brand,
          boxShadow: 'none',
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: sol.brand,
        },
      },
    },
  },
});

export default theme;
export { sol };
